'use strict';

import * as moment from 'moment';

class OperationTasksController {
  static $inject = ['OperationTasksService', 'AgenciesService', '$scope', '$q'];
  OperationTasksService: any;
  AgenciesService: any;
  $scope: any;
  $q: any;

  query: any = {};
  order: any = {};
  onPagination: any;
  onReorder: any;
  operationTasks: any[];
  operationTasksCount: number;
  whereFrom: Date;
  whereTo: Date;
  whereName: string;
  whereIncludeInactive: boolean = false;
  showSpin: boolean = false;

  filterExpired: string = '';
  filter: any[];

  searchAgencyText: string = '';
  agencies: any[] = [];

  constructor(
    OperationTasksService, AgenciesService, $scope, $q
  ) {
    Object.assign(this, { OperationTasksService, AgenciesService, $scope, $q });

    this.query = {
      limit: 25,
      page: 1,
      include: [
        {
          relation: 'operationProcedure',
          scope: {
            include: [
              {
                relation: 'operation',
                scope: {
                  include: ['operationType', 'holder', 'vehicle', 'agency']
                }
              }
            ]
          }
        }
      ],
      where: {},
      order: ''
    };
    this.getOperationTasks();

    this.onPagination = () => {
      this.getOperationTasks();
    };

    this.onReorder = () => {
      this.order == '-dueat'
        ? (this.query.order = 'dueAt DESC')
        : (this.query.order = 'dueAt ASC');
      this.getOperationTasks();
    };
  }

  getOperationTasks() {
    if (this.whereFrom && this.whereTo && this.whereTo < this.whereFrom) {
      this.whereTo = this.whereFrom;
    }
    let opts = Object.assign({}, this.query);
    let today = moment(new Date())
      .subtract(1, 'day')
      .endOf('day')
      .toDate();

    const constraints = [];
    /* eslint-disable indent */

    const from = this.whereFrom
      ? moment(this.whereFrom)
          .startOf('day')
          .toDate()
      : null;
    const to = this.whereTo
      ? moment(this.whereTo)
          .endOf('day')
          .toDate()
      : null;

    if (from && to) {
      constraints.push({
        dueAt: {
          between: [from, to]
        }
      });
    } else if (from) {
      constraints.push({
        dueAt: {
          gte: from
        }
      });
    } else if (to) {
      constraints.push({
        dueAt: {
          lt: to
        }
      });
    }

    if (this.filter) {
      if (this.filter.find(x => x == 'expired')) {
        constraints.push({ dueAt: { lt: today } });
      } else if (this.filter.find(x => x == 'notExpired')) {
        constraints.push({ dueAt: { gte: today } });
      }

      if (this.filter.find(x => x == 'done')) {
        constraints.push({ completedAt: { neq: null } });
      } else if (this.filter.find(x => x == 'notDone')) {
        constraints.push({ completedAt: { eq: null } });
      }

      if (this.whereName) {
        constraints.push({ label: { ilike: `%${this.whereName}%` } });
      }
    } else {
      if (this.whereName) {
        constraints.push({
          label: { ilike: `%${this.whereName}%` }
        });
      }
    }
    if (!this.whereIncludeInactive) {
      constraints.push({
        or: [
          {
            deactivated: null
          },
          {
            deactivated: false
          }
        ]
      });
    }

    if (this.agencies.length > 0) {
      constraints.push({
        agencyId: {
          inq: this.agencies.map(a => a.id)
        }
      });
    }

    if (constraints.length > 1) {
      opts.where.and = constraints;
    } else {
      opts.where = constraints[0];
    }

    /* eslint-enable indent */
    this.showSpin = true;
    let queryReady = this.OperationTasksService.getModels(opts).then(
      operationTasks => {
        this.operationTasks = operationTasks;
      }
    );
    let countReady = this.OperationTasksService.getCount(opts).then(result => {
      this.operationTasksCount = result.count;
    });

    this.$q.all([queryReady, countReady]).finally(() => {
      this.showSpin = false;
    });
  }

  getDifference(due, completed) {
    let ret;
    let a = moment(due);
    let b = moment(new Date());

    completed ? (ret = '-') : (ret = b.diff(a, 'days')); // 1
    return ret;
  }

  addAgency() {
    this.getOperationTasks();
  }

  removeAgency() {
    this.getOperationTasks();
  }

  queryAgencySearch(text: string) {
    return this.AgenciesService.find({
      filter: {
        where: {
          name: {
            regexp: `^.*${text}.*$/i`
          }
        }
      }
    });
  }
}

export default OperationTasksController;
